import { render, staticRenderFns } from "./dettaglioCustomEdit.vue?vue&type=template&id=c965dbec"
import script from "./dettaglioCustomEdit.vue?vue&type=script&lang=js"
export * from "./dettaglioCustomEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports